import { getHoseCodesFromDiastereotopicID, ensureHeterotopicChiralBonds, groupDiastereotopicAtomIDs, } from 'openchemlib-utils';
export function getFilteredIDiaIDs(molecule, options) {
    const { maxSphereSize, diaIDs } = options;
    molecule.addImplicitHydrogens();
    molecule.addMissingChirality();
    ensureHeterotopicChiralBonds(molecule);
    const molfile = molecule.toMolfile();
    const groupedDiaIDs = groupDiastereotopicAtomIDs(diaIDs, molecule, {
        atomLabel: 'C',
    });
    const carbonDiaIDs = groupedDiaIDs.sort((a, b) => {
        if (a.atomLabel === b.atomLabel) {
            return b.counter - a.counter;
        }
        return a.atomLabel < b.atomLabel ? 1 : -1;
    });
    const OCL = molecule.getOCL();
    for (const diaId of carbonDiaIDs) {
        diaId.hose = getHoseCodesFromDiastereotopicID(OCL.Molecule.fromIDCode(diaId.oclID), {
            maxSphereSize,
        });
    }
    const toReturn = {
        molfile,
        carbonDiaIDs: carbonDiaIDs,
    };
    return toReturn;
}
//# sourceMappingURL=getFilteredIDiaIDs.js.map